import { hydrateRoot, createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { SSRDataProvider } from "@/lib/ssr-context";

declare global {
  interface Window {
    __SSR_DATA__?: Record<string, unknown>;
    __SSR_RENDER_OK__?: boolean;
  }
}

const rootElement = document.getElementById("root")!;
const ssrData = window.__SSR_DATA__ || {};

// Wrap with the same SSRDataProvider the server uses so the client tree matches
// the server's rendered output. Without this, components reading useSSRData()
// would see {} on first render and diverge from the SSR markup.
const app = (
  <SSRDataProvider value={ssrData}>
    <App />
  </SSRDataProvider>
);

// Only hydrate when the markup in #root truly came from React's SSR renderer.
// In dev mode the static FCP shell is present; in production SSR-failure paths
// the server emits hand-built fallback HTML. Both would mismatch React's tree,
// so we use createRoot to do a clean client render instead.
if (window.__SSR_RENDER_OK__ === true) {
  hydrateRoot(rootElement, app);
} else {
  rootElement.innerHTML = "";
  createRoot(rootElement).render(app);
}
